import React from "react";
import { Form, Input } from "antd";

const FormInput = ({
  label,
  name,
  rules,
  placeholder,
  size = "large",
  type = "text",
  minLength = undefined,
  maxLength = undefined,
  showCount = false,
  ...rest
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      {...rest}
      className="custom-input"
    >
      <Input
        placeholder={placeholder}
        type={type}
        size={size}
        maxLength={maxLength}
        minLength={minLength}
        showCount={showCount}
      />
    </Form.Item>
  );
};
export default FormInput;
